// components/Sidebar/AdminMenu.jsx
import { useState, useEffect } from 'react';
import { List, ListItemButton, Collapse, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useAdminAlert } from '../../contexts/AdminAlertContext'; // ✅ 추가

export default function AdminMenu({ onItemClick = () => { } }) {
  const location = useLocation();
  const path = location.pathname;

  /* prefix 매칭 함수 */
  const match = prefix => path.startsWith(prefix);

  /* 섹션 열림 상태 (URL 기준 초기화) */
  const [open, setOpen] = useState(match('/main/admin'));
  const [openContent, setOpenContent] = useState(match('/main/admin/content-manager') ||
    match('/main/admin/post-comment'));
  const [openUser, setOpenUser] = useState(match('/main/admin/users') ||
    match('/main/admin/reports'));
  const [openTitle, setOpenTitle] = useState(match('/main/admin/gacha-title'));

  /* URL 변경 시 열림 상태 재조정 */
  useEffect(() => {
    setOpen(match('/main/admin'));
    setOpenContent(match('/main/admin/content-manager') || match('/main/admin/post-comment'));
    setOpenUser(match('/main/admin/users') || match('/main/admin/reports'));
    setOpenTitle(match('/main/admin/gacha-title'));
  }, [location]);   // eslint-disable-line react-hooks/exhaustive-deps

  const { hasPendingCoupon, clearPending } = useAdminAlert(); // ✅ 알림 context 사용

  return (
    <>
      {/* 관리자 메뉴 루트 토글 */}
      <ListItemButton onClick={() => setOpen(!open)}>
        <ListItemText
          primary="⚙️ 관리자 메뉴"
          primaryTypographyProps={{
            fontWeight: open ? 700 : 400,
            color: hasPendingCoupon && !match('/main/admin/store') ? 'error.main' : 'inherit',
            className: hasPendingCoupon && !match('/main/admin/store') ? 'blink' : '',
          }}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{ pl: 3 }}>

          {/* 📁 콘텐츠 관리 섹션 */}
          <ListItemButton onClick={() => setOpenContent(!openContent)}>
            <ListItemText
              primary="📁 콘텐츠 관리"
              primaryTypographyProps={{ fontWeight: openContent ? 700 : 400 }}
            />
            {openContent ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={openContent} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: 3 }}>
              <ListItemButton
                component={Link}
                to="/main/admin/content-manager"
                onClick={onItemClick}

              >
                <ListItemText
                  primary="📋 카테고리 생성"
                  primaryTypographyProps={{
                    fontWeight: match('/main/admin/content-manager') ? 700 : 400,
                  }}
                />
              </ListItemButton>
              <ListItemButton
                component={Link}
                to="/main/admin/post-comment"
                onClick={onItemClick}
              >
                <ListItemText
                  primary="📝 글 · 채팅 관리"
                  primaryTypographyProps={{
                    fontWeight: match('/main/admin/post-comment') ? 700 : 400,
                  }}
                />
              </ListItemButton>
            </List>
          </Collapse>

          {/* 👥 유저 & 커뮤니티 섹션 */}
          <ListItemButton onClick={() => setOpenUser(!openUser)}>
            <ListItemText
              primary="👥 유저 & 커뮤니티"
              primaryTypographyProps={{ fontWeight: openUser ? 700 : 400 }}
            />
            {openUser ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={openUser} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: 3 }}>
              <ListItemButton
                component={Link}
                to="/main/admin/users"
                onClick={onItemClick}
              >
                <ListItemText
                  primary="👤 회원 관리"
                  primaryTypographyProps={{
                    fontWeight: match('/main/admin/users') ? 700 : 400,
                  }}
                />
              </ListItemButton>
              <ListItemButton
                component={Link}
                to="/main/admin/reports"
                onClick={onItemClick}
              >
                <ListItemText
                  primary="🚨 신고 관리"
                  primaryTypographyProps={{
                    fontWeight: match('/main/admin/reports') ? 700 : 400,
                  }}
                />
              </ListItemButton>
            </List>
          </Collapse>

          {/* 🏷 칭호 & 뽑기 섹션 */}
          <ListItemButton onClick={() => setOpenTitle(!openTitle)}>
            <ListItemText
              primary="🏷 칭호 & 뽑기"
              primaryTypographyProps={{ fontWeight: openTitle ? 700 : 400 }}
            />
            {openTitle ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={openTitle} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: 3 }}>
              <ListItemButton
                component={Link}
                to="/main/admin/gacha-title"
                onClick={onItemClick}
              >
                <ListItemText
                  primary="🎯 뽑기 & 칭호 설정"
                  primaryTypographyProps={{
                    fontWeight: match('/main/admin/gacha-title') ? 700 : 400,
                  }}
                />
              </ListItemButton>
            </List>
          </Collapse>

          {/* 🛒 쿠폰 & 이모티콘 관리 단일 메뉴 */}
          <ListItemButton
            component={Link}
            to="/main/admin/store"
            onClick={() => {
              onItemClick();
              clearPending(); // ✅ 클릭 시 깜빡임 해제
            }}
          >
            <ListItemText
              primary="🛒 쿠폰 & 이모티콘 관리"
              primaryTypographyProps={{
                fontWeight: match('/main/admin/store') ? 700 : 400,
                color: hasPendingCoupon && !match('/main/admin/store') ? 'error.main' : 'inherit',
                className: hasPendingCoupon && !match('/main/admin/store') ? 'blink' : '',
              }}
            />
          </ListItemButton>
        </List>
      </Collapse>
    </>
  );
}
